import { useEffect, useState } from "react";

function authHeaders() {
  if (typeof window !== "undefined" && window._kcToken) {
    return { Authorization: `Bearer ${window._kcToken}` };
  }
  if (typeof window !== "undefined" && window.localStorage) {
    for (const k of ["internal_token", "token", "access_token", "auth_token", "jwt", "ffw_token"]) {
      const t = window.localStorage.getItem(k);
      if (t) return { Authorization: `Bearer ${t}` };
    }
  }
  return {};
}

let _cache = null;
let _loadingPromise = null;
const _listeners = new Set();

async function loadInfo() {
  if (_loadingPromise) return _loadingPromise;
  _loadingPromise = (async () => {
    try {
      const r = await fetch("/api/me/info", { headers: authHeaders(), credentials: "include" });
      if (r.ok) {
        _cache = await r.json();
      } else {
        _cache = { is_admin: false, permissions: [], gremium_rollen: {} };
      }
    } catch {
      _cache = { is_admin: false, permissions: [], gremium_rollen: {} };
    } finally {
      _loadingPromise = null;
      _listeners.forEach(fn => fn(_cache));
    }
    return _cache;
  })();
  return _loadingPromise;
}

export function reloadMeInfo() {
  _cache = null;
  return loadInfo();
}

export function useMeInfo() {
  const [info, setInfo] = useState(_cache);
  useEffect(() => {
    if (_cache) {
      setInfo(_cache);
    } else {
      loadInfo().then(setInfo);
    }
    const listener = (data) => setInfo(data);
    _listeners.add(listener);
    return () => _listeners.delete(listener);
  }, []);
  return { info, ready: info !== null };
}

export function useIsAdmin() {
  const { info } = useMeInfo();
  return Boolean(info?.is_admin);
}

export function useGremiumRole(gremiumId) {
  const { info } = useMeInfo();
  if (!info || !gremiumId) return null;
  return info.gremium_rollen?.[gremiumId] || null;
}

const ROLE_RANK = { mitglied: 1, schriftfuehrer: 2, vorsitz: 3 };
export function roleSatisfies(actual, required) {
  if (!required) return true;
  if (!actual) return false;
  return (ROLE_RANK[actual] || 0) >= (ROLE_RANK[required] || 99);
}

export function RoleGate({ gremiumId, role, fallback = null, children }) {
  const userRole = useGremiumRole(gremiumId);
  const isAdmin = useIsAdmin();
  if (isAdmin) return children;
  return roleSatisfies(userRole, role) ? children : fallback;
}
